export default __webpack_public_path__ + "react-assets/contacts.svg";